import React from 'react'

function Profile() {
  return (
    <div className="ljSectionData w-100 clearfix" id="ljSectionData">Comming Soon</div>
  )
}

export default Profile